/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
import { parseHTML } from '@/utils/parseHTML';
import { Stack } from '@mui/material';
import { FC, useContext } from 'react';

export const ProductDetailsPromos: FC = () => {
	const { promos, promosDetails } = useContext(ContentContext) as ReturnType<
		typeof useProductDetails
	> &
		ReturnType<typeof useSkuListTable>;
	const promosProduct =
		promos && promos.length
			? promos?.filter((promo) => promo.startsWith('DP_PROMO_PDP_PRODUCT'))
			: [];

	const promosDetailsProduct = promosProduct.map((elm) =>
		promosDetails.find(
			(prm: { description: { shortDescription: string } }) =>
				prm.description.shortDescription === elm
		)
	);

	return (
		<Stack display="flex" flexDirection="column" justifyContent="left">
			{promosDetailsProduct && promosDetailsProduct.length
				? promosDetailsProduct.map((prm) => parseHTML(prm.description.longDescription))
				: null}
		</Stack>
	);
};
